import React from 'react';
import { Card } from '../ui/Card';
import { BoxIcon } from 'lucide-react';
interface CategoryCardProps {
  title: string;
  icon: BoxIcon;
  description: string;
  color: string;
  onClick?: () => void;
}
export function CategoryCard({
  title,
  icon: Icon,
  description,
  color,
  onClick
}: CategoryCardProps) {
  return <button onClick={onClick} className="flex flex-col items-center text-center p-4 bg-white rounded-xl border border-gray-100 shadow-sm hover:shadow-md transition-all w-full h-full" data-id="element-76">
      <div className={`p-3 rounded-full ${color} text-white mb-3 shadow-sm`} data-id="element-77">
        <Icon size={24} data-id="element-78" />
      </div>
      <h3 className="font-bold text-gray-900 text-sm mb-1" data-id="element-79">{title}</h3>
      <p className="text-[10px] text-gray-500 leading-tight" data-id="element-80">{description}</p>
    </button>;
}